import { createSearchActions } from './search/frontend-html5.actions';
export const createFlightResultsActions = ({
  search
}) => ({
  search: createSearchActions(search)
});